import moment, { Moment } from 'moment-timezone';

const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;

/**
 * Returns an interval based on the time difference between now and the given
 * time
 */
export function getIntervalBasedOnTimeDifference(
  dateTime: Moment | null,
): number {
  const diff = Math.abs(dateTime?.diff(moment()) ?? 0);

  if (!dateTime || diff > 2 * hour) {
    return hour;
  }

  if (diff > 2 * minute) {
    return minute;
  }

  return second;
}
